import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConstants, IPermission } from 'src/app/models';
import { Observable } from 'rxjs';
import { BaseResponse, IPermissionResponse, IPermissionsByRoleResponse, IPermissionsResponse } from 'src/app/models/responses';
import { IResponse } from '../../models/responses';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private httpClient: HttpClient) { }

  StorePermission(_permission: IPermission): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/StorePermission`;
    
    return this.httpClient.post<BaseResponse>(url, _permission, { headers });
  }

  Get(): Observable<IResponse<IPermission[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/GetPermissions`;
    
    return this.httpClient.get<IResponse<IPermission[]>>(url, { headers });
  }

  GetPermission(_permissionId: number): Observable<IResponse<IPermission>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/GetPermissionById?id=${_permissionId}`;
    
    return this.httpClient.get<IResponse<IPermission>>(url, { headers });
  }

  GetPermissionsByRole(_IdRole: number): Observable<IResponse<IPermission[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/GetPermissionsByRole?id=${_IdRole}`;
    
    return this.httpClient.get<IResponse<IPermission[]>>(url, { headers });
  }

  GetPermissionsByUser(_IdUser: number): Observable<IResponse<IPermission[]>> {

    const url = `${AppConstants.API_URL}api/Permission/GetPermissionsByUser?id=${_IdUser}`;
    
    return this.httpClient.get<IResponse<IPermission[]>>(url);
  }

  Put(_permission: IPermission): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/StorePermission`;
    
    return this.httpClient.post<BaseResponse>(url, _permission, { headers });
  }

  PutByRole(_RoleId: number, _permissions: IPermission[]): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Permission/StorePermissionsByRole`;
    
    return this.httpClient.post<BaseResponse>(url, {
      'RoleId': _RoleId,
      'Permissions': _permissions
    }, { headers });
  }
}
